import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3f9e11ff&scoped=true&lang=css"

import exportComponent from "/Users/cindy/mydoc/project/vue-antd-tool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9e11ff"]])

export default __exports__